import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Monads, monads, monads, monads",
  "description": "",
  "published": "2012-09-03T00:00:00.000Z",
  "redirect_from": ["/blog/monads-monads-monads-monads/swizec/5206"],
  "categories": "Functor, Haskell, Languages, Monad, Programming, Tutorial, Uncategorized",
  "hero": "./img/wikiupload-2-23-Monad-tutorials-chart.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.haskell.org/haskellwiki/Monad_tutorials_timeline"
      }}>{`Monad tutorials`}</a>{` have achieved what many startups crave - hockey stick growth.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "300px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/49065f0157477887e2b76194dcf57427/5a46d/wikiupload-2-23-Monad-tutorials-chart.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2052a802%20802%200%2000-2%2034v1c2%200%203%2022%201%2023v1c2%200%201%2021-1%2022v1c3%200%203%2021%200%2023v1c3%200%203%2045%200%2045v1c3%202%203%2046%200%2046v1l2%202h1c0-3%2016-3%2016%200h1c0-3%2017-3%2017%200h1c0-2%201-2%208-2s8%200%208%202h1c0-2%201-2%208-2s8%200%208%202h1c0-3%2017-3%2017%200h1c0-3%2016-3%2016%200h1c0-3%2016-3%2016%200h1c0-3%2017-3%2017%200h1c0-3%2016-3%2016%200h1c0-2%201-2%209-2s9%200%209%202h1c0-2%201-2%208-2s8%200%208%202h1c0-2%201-2%208-2s8%200%208%202h1c0-3%2017-3%2017%200h1c0-2%201-2%208-2s8%200%208%202h1c0-2%201-2%208-2s8%200%208%202h1c0-2%201-2%208-2%208%200%209%200%209%202h1c0-3%2016-3%2016%200h1c0-2%201-2%208-2s8%200%208%202h1c0-3%2017-3%2017%200h1c0-3%2016-3%2016%200%201%201%201%201%201-1v-2h-96a6217%206217%200%2001-219-2c15%200%2019%200%2025-2%207-2%2011-2%2037-3h29l7-5%207-4h17l21-1%2012-3%2014-4c5-1%208-3%2016-9%204-4%2013-9%2018-12%208-5%209-6%2012-11l8-15%2015-35c9-20%208-18%2017-21%207-1%208-2%2025-16%2010-8%2021-16%2026-18%208-5%209-6%208-7-2-2-19%209-36%2023-11%209-18%2013-20%2014l-15%205c0%202-16%2040-21%2049-14%2027-12%2024-22%2030l-17%2011-12%208-17%205c-12%203-13%203-30%203h-18l-9%205-8%204h-26c-24%200-26%200-34%203-8%202-11%202-27%202-13%200-18%200-24%202l-10%202-1-104-1-92m21%20231c-2%201-1%206%202%207l2%201-3%201h-2c1%203%205%202%207-1l1-2%201%202c1%203%205%204%206%201%202-3%201-8-1-9s-5%200-5%203l-1%201-1-1c0-3-4-4-6-3m157%200c-2%201-2%203-2%206%200%204%201%205%203%205s3%200%204-3l1-2%201%202c1%203%205%204%206%201%202-3%201-8-1-9s-5%200-5%203l-1%201-1-1c0-3-3-4-5-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/49065f0157477887e2b76194dcf57427/ca0a1/wikiupload-2-23-Monad-tutorials-chart.webp 223w", "/static/49065f0157477887e2b76194dcf57427/c85cb/wikiupload-2-23-Monad-tutorials-chart.webp 300w"],
                "sizes": "(max-width: 300px) 100vw, 300px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/49065f0157477887e2b76194dcf57427/e92b6/wikiupload-2-23-Monad-tutorials-chart.png 223w", "/static/49065f0157477887e2b76194dcf57427/5a46d/wikiupload-2-23-Monad-tutorials-chart.png 300w"],
                "sizes": "(max-width: 300px) 100vw, 300px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/49065f0157477887e2b76194dcf57427/5a46d/wikiupload-2-23-Monad-tutorials-chart.png",
                "alt": "Monad tutorials growth",
                "title": "Monad tutorials growth",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Monad tutorials growth`}</figcaption>{`
  `}</figure></p>
    <p>{`This isn't a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Monad_%28functional_programming%29",
        "title": "Monad (functional programming)"
      }}>{`monad`}</a>{` tutorial.`}</p>
    <p>{`It `}<em parentName="p">{`could`}</em>{` be a monad tutorial, but I still don't understand monads. I don't think I ever will.`}</p>
    <p>{`Monads were invented to fuck with us developers of lesser minds, the ones who don't want to bend over backwards to maintain `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Purely_functional",
        "title": "Purely functional"
      }}>{`functional purity`}</a>{` and would perhaps rather ... you know ... get things done instead. Really, sometimes I just want things to `}<em parentName="p">{`work`}</em>{`. I don't even care how.`}</p>
    <p>{`You see, monads are just a wrapper around values. Their rhetoric is `}<em parentName="p">{`Hey, there's this value here, but there's a whole bunch of conditions involved. You don't really need to know about those, just play according to the rules`}</em>{`.`}</p>
    <p>{`And then you're like `}<em parentName="p">{`Okay ... but just give me the value? I understand all the conditions, but I don't care about them, I just want the value.`}</em></p>
    <p>{`Well no, no you can't have the value just like that. That would be silly. You can unwrap the monad, play around with the value, fiddle with all the knobs and dials, but once you're done, you have to put it back into the monad where it's safe.`}</p>
    <p>{`Monads are the ultimate Dad's shiny red corvette that he lets you drive around the parking lot, but you must always put it back in the garage and never drive anywhere with it.`}</p>
    <p>{`I wish my dad had a corvette.`}</p>
    <h2 {...{
      "id": "monads-annoy-me"
    }}>{`Monads annoy me`}</h2>
    <p>{`Really, they're just annoying. Annoying little shits.`}</p>
    <p>{`Yesterday I was doing something simple:`}</p>
    <ul>
      <li parentName="ul">{`take some values from mongodb`}</li>
      <li parentName="ul">{`draw a graph`}</li>
    </ul>
    <p>{`Simple right? Can't be more than ten or twenty lines of either python or javascript.`}</p>
    <p>{`I spent the entire day in `}<strong parentName="p"><em parentName="strong">{`Monad Hell `}</em></strong>{`getting it done in `}<a parentName="p" {...{
        "href": "http://haskell.org",
        "title": "Haskell (programming language)"
      }}>{`Haskell`}</a>{`. And that's after the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Dependency_hell",
        "title": "Dependency hell"
      }}>{`dependency hell`}</a>{` of installing `}<em parentName="p">{`Chart`}</em>{` on my computer ... `}<em parentName="p">{`cabal`}</em>{` isn't very good, but that's a whole different blogpost.`}</p>
    <p>{`You see, when you take some values out of Mongo, the operation might have failed! You know it didn't, you know everything should just crash and burn and alarms should be going off if it did, so it's never going to. Not as far as this piece of code is concerned.`}</p>
    <p>{`But Haskell doesn't know that. It `}<em parentName="p">{`might have`}</em>{` failed. So everything you get out is wrapped in the `}<em parentName="p">{`Maybe`}</em>{` monad. Except sometimes it isn't.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-haskell"
      }}>{`known'::[Document] -> (UTCTime, Double)
known' docs = (cast' $ (valueAt "time") (docs!!0),
               cast' $ (valueAt "amount") (docs!!0))

-- Couldn't match expected type \`Double' with actual type \`Maybe a0'
--    In the expression: cast' $ (valueAt "amount") (docs !! 0)
`}</code></pre>
    <p>{`Great. Ok so those are maybes, don't really care, moving on.`}</p>
    <p>{`By the way, if the function really `}<em parentName="p">{`does`}</em>{` fail it either dies with an index out of bounds error (not enough Documents) or with some sort of `}<em parentName="p">{`fields weren't there`}</em>{` error, if you give it the wrong sort of Document. So it's not like it could actually fail in a way that it would still work and those Maybes would be warranted.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-haskell"
      }}>{`plot.hs:52:7:
    Couldn't match expected type \`Double'
                with actual type \`Maybe Double'
    In the first argument of \`(+)', namely \`money'
    In the first argument of \`(-)', namely \`money + p'
    In the expression: money + p -
`}</code></pre>
    <p>{`Gah!`}</p>
    <p>{`At this point you're (or at least I was) getting frustrated and you suddenly can't remember where that short and sweet description of `}<em parentName="p">{`instance`}</em>{` was even though it kept slapping you in the face the whole time you were trying to figure out how to take a value out of some monad or another `}<em parentName="p">{`and keep it the fuck out.`}</em></p>
    <p>{`I don't know what instances are, not completely, but they look like a magic thing that can make `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Type_conversion",
        "title": "Type conversion"
      }}>{`type conversions`}</a>{` automatic. And that's awesome so I need to look it up.`}</p>
    <p>{`Anyway, you settle for a simple function`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-haskell"
      }}>{`double'::Maybe Double -> Double
double' Nothing = 0.0
double' (Just x) = x
`}</code></pre>
    <p>{`Everything works! Yay!`}</p>
    <p>{`At no point in execution does that default value actually happen. Because you've made sure externally that the operation Haskell is unsure of will never fail, but hey, you're happy, haskell is happy, the code is somewhat ugly.`}</p>
    <p>{`But at least it works.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/09/graph1.png",
        "alt": "Money graph",
        "title": "Money graph"
      }}></img></p>
    <p>{`Now I just wish the graph wasn't a fluke of currency conversions.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.haskellforall.com/2012/06/you-could-have-invented-free-monads.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_38_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.haskellforall.com/2012/06/you-could-have-invented-free-monads.html"
        }}>{`Why free monads matter`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://scientopia.org/blogs/goodmath/2012/08/19/monads-and-programming/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/107656675_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://scientopia.org/blogs/goodmath/2012/08/19/monads-and-programming/"
        }}>{`Monads and Programming`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.haskell.org/haskellwiki/index.php?title=Monad_tutorials_timeline&diff=49591&oldid=prev"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_55_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.haskell.org/haskellwiki/index.php?title=Monad_tutorials_timeline&diff=49591&oldid=prev"
        }}>{`Monad tutorials timeline`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.haskell.org/haskellwiki/index.php?title=Hask&diff=49966&oldid=prev"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_89_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.haskell.org/haskellwiki/index.php?title=Hask&diff=49966&oldid=prev"
        }}>{`Hask`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://unfoldthat.com/2011/04/02/python-monads.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_12_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://unfoldthat.com/2011/04/02/python-monads.html"
        }}>{`Python Monads - new approach`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=bb1fb710-d766-4afc-8466-3a22e2ebd230",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      